import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';

import { Button } from 'components/Button';
import { rejectionReasonOptions } from '../../constants';

/**
 * "What went wrong?" as a bottom sheet.
 *
 * The reasons are radio rows rather than a dropdown: six options on a phone are
 * cheaper to read and tap than a select that covers them one at a time, and each
 * row is a full-width 44px target.
 *
 * Sending without a reason is answered inline rather than by a disabled button,
 * so the employee is told what is missing instead of being left tapping a
 * control that does nothing.
 */
const RejectReasonSheet = ({ open, item, submitting, onCancel, onSubmit }) => {
  const [reason, setReason] = useState(null);
  const [detail, setDetail] = useState('');
  const [error, setError] = useState('');

  // Each garment is its own question; reopening must never inherit the last
  // answer and quietly file the wrong reason against a different item.
  useEffect(() => {
    if (open) {
      setReason(null);
      setDetail('');
      setError('');
    }
  }, [open, item?.id]);

  const handleSend = () => {
    if (!reason) {
      setError('Choose what went wrong so the store knows what to send instead.');
      return;
    }
    onSubmit({ reason, reason_detail: detail.trim() });
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={item ? `Report a problem — ${item.uniform_item_name}` : 'Report a problem'}
      className="myu-sheet"
      footer={[
        <Button
          key="cancel"
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={onCancel}
          disabled={submitting}
          label="Cancel"
        />,
        <Button
          key="send"
          type="button"
          className="btn btn-primary btn-sm"
          onClick={handleSend}
          disabled={submitting}
          label={submitting ? 'Sending…' : 'Send'}
        />,
      ]}
    >
      {error && <p className="myu-sheet-error">{error}</p>}

      <div className="myu-reasons" role="radiogroup" aria-label="What went wrong?">
        {rejectionReasonOptions.map(option => (
          <label className="myu-reason" key={option.value}>
            <input
              type="radio"
              name="myu-reject-reason"
              value={option.value}
              checked={reason === option.value}
              onChange={() => { setReason(option.value); setError(''); }}
            />
            {option.label}
          </label>
        ))}
      </div>

      <label className="myu-meta" htmlFor="myu-reject-detail">
        Anything else? (optional)
      </label>
      <textarea
        id="myu-reject-detail"
        className="form-control"
        rows={3}
        value={detail}
        onChange={e => setDetail(e.target.value)}
      />
    </Modal>
  );
};

export default RejectReasonSheet;
